import React, { createContext, useReducer } from 'react'

export const SET_CUSTOMER_DATA = 'SET_CUSTOMER_DATA'
export const UPDATE_CHANGE_CUSTOMER_DATA = 'UPDATE_CHANGE_CUSTOMER_DATA'
export const SET_SELECTED_CUSTOMER_DATA = 'SET_SELECTED_CUSTOMER_DATA'
export const SHOW_CUSTOMER_FORM = 'SHOW_CUSTOMER_FORM'

const Reducer = (data, payload) => {
  switch (payload.type) {
    case UPDATE_CHANGE_CUSTOMER_DATA: {
      let tempData = [...data.data]
      tempData[payload.data.index] = payload.data
      return { ...data, data: tempData, showFormPopup: false }
    }
    case SET_SELECTED_CUSTOMER_DATA: {
      return {
        ...data,
        selectedObject: payload.data,
        showFormPopup: payload?.showFormPopup,
      }
    }
    case SHOW_CUSTOMER_FORM: {
      return {
        ...data,
        selectedObject: payload.data,
        showFormPopup: payload.showFormPopup,
      }
    }
    case SET_CUSTOMER_DATA: {
      return { ...data, data: payload.data }
    }
    default: {
      return {}
    }
  }
}

const initialState = {
  plants: [],
  selectedObject: {},
  showFormPopup: false,
  data: [],
}

const CustomerStore = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState)

  return (
    <CustomerContext.Provider value={[state, dispatch]}>
      {children}
    </CustomerContext.Provider>
  )
}

export const CustomerContext = createContext(initialState)
export default CustomerStore
